// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"_c0955fa","active":"_c2cb241","invalid":"_5c90e90","dropzoneHidden":"_07b158d","titleWrapper":"_c1dc5f9","errorBigSpacing":"_4ae969f","errorSmallSpacing":"_8ed965e"};